const styles = theme => ({
  selectWrap: {
    position: 'relative',
    display: 'flex',
  },
  select: {
    width: '100%',
    boxSizing: 'border-box',
    appearance: 'none',
    WebkitAppearance: 'none',
    padding: '11px 36px 11px 12px',
    border: '1px solid rgba(145,158,171,.32)',
    borderRadius: '8px',
    outline: 'none',
    background: '#fff',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '14px',
    color: '#002E47',
    '&:focus': {
      borderColor: '#015FFB',
    },
  },
  selectChevron: {
    position: 'absolute',
    top: '50%',
    right: 12,
    transform: 'translateY(-50%)',
    display: 'inline-flex',
    pointerEvents: 'none',
    color: '#637381',
  },
  sectionLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    fontWeight: 500,
    color: '#002E47',
  },
  optional: {
    fontWeight: 400,
    color: '#919EAB',
  },
  courseInfo: {
    backgroundColor: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '12px',
    padding: '16px 18px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  courseInfoTitleBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  courseInfoTitleExample: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  courseInfoCharCount: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '4px',
  },
})

export default styles
